import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const types = {
  facebook: {
    logo: (
      <path
        data-test="facebook"
        d="M23.34,34V23.07H27l.55-4.28H23.34V16.06c0-1.24.35-2.08,2.12-2.08h2.27V10.17A31.29,31.29,0,0,0,24.44,10C21.18,10,19,12,19,15.64v3.15H15.27v4.28H19V34Z"
      />
    ),
    color: '#4267b2',
  },
  instagram: {
    logo: (
      <g data-test="instagram">
        <path d="M22,12.16c3.2,0,3.58,0,4.85.07a6.64,6.64,0,0,1,2.23.41,4,4,0,0,1,2.28,2.28,6.64,6.64,0,0,1,.41,2.23c.06,1.27.07,1.64.07,4.85s0,3.58-.07,4.85a6.64,6.64,0,0,1-.41,2.23,4,4,0,0,1-2.28,2.28,6.64,6.64,0,0,1-2.23.41c-1.27.06-1.64.07-4.85.07s-3.58,0-4.85-.07a6.64,6.64,0,0,1-2.23-.41,4,4,0,0,1-2.28-2.28,6.64,6.64,0,0,1-.41-2.23c-.06-1.27-.07-1.64-.07-4.85s0-3.58.07-4.85a6.64,6.64,0,0,1,.41-2.23,4,4,0,0,1,2.28-2.28,6.64,6.64,0,0,1,2.23-.41c1.27-.06,1.64-.07,4.85-.07M22,10c-3.26,0-3.67,0-4.95.07a8.81,8.81,0,0,0-2.91.56,6.14,6.14,0,0,0-3.51,3.51,8.81,8.81,0,0,0-.56,2.91C10,18.33,10,18.74,10,22s0,3.67.07,4.95a8.81,8.81,0,0,0,.56,2.91,6.14,6.14,0,0,0,3.51,3.51,8.81,8.81,0,0,0,2.91.56C18.33,34,18.74,34,22,34s3.67,0,4.95-.07a8.81,8.81,0,0,0,2.91-.56,6.14,6.14,0,0,0,3.51-3.51,8.81,8.81,0,0,0,.56-2.91C34,25.67,34,25.26,34,22s0-3.67-.07-4.95a8.81,8.81,0,0,0-.56-2.91,6.14,6.14,0,0,0-3.51-3.51,8.81,8.81,0,0,0-2.91-.56C25.67,10,25.26,10,22,10Z" />
        <path d="M22,15.84A6.16,6.16,0,1,0,28.16,22,6.16,6.16,0,0,0,22,15.84ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z" />
        <circle cx="28.41" cy="15.59" r="1.44" />
      </g>
    ),
    color: '#696a6a',
  },
  linkedin: {
    logo: (
      <path
        data-test="linkedin"
        d="M15.37,34h-5V18h5ZM12.88,15.79a2.88,2.88,0,1,1,2.88-2.88A2.88,2.88,0,0,1,12.88,15.79ZM34,34H29V26.2C29,24.34,29,22,26.45,22s-3,2-3,4.11V34h-5V18h4.77v2.19h.07A5.23,5.23,0,0,1,28,17.58c5,0,6,3.31,6,7.62Z"
      />
    ),
    color: '#0077b5',
  },
  snapchat: {
    logo: (
      <g data-test="snapchat">
        <path d="M22.15,33h-.3a5.14,5.14,0,0,1-3.15-1.24,4.6,4.6,0,0,0-1.82-.93,5.89,5.89,0,0,0-1-.08,6.55,6.55,0,0,0-1.33.15,2.9,2.9,0,0,1-.49.07.31.31,0,0,1-.34-.25c-.06-.19-.09-.37-.13-.54-.1-.45-.17-.73-.36-.76-2.21-.34-2.84-.81-3-1.14a.43.43,0,0,1,0-.14.25.25,0,0,1,.21-.26c3.39-.56,4.92-4,5-4.18h0a1.29,1.29,0,0,0,.12-1.09c-.23-.55-1-.79-1.5-.95l-.33-.11c-1-.4-1.09-.8-1-1a1,1,0,0,1,.92-.6.65.65,0,0,1,.27.05,2.92,2.92,0,0,0,1.21.32,1,1,0,0,0,.72-.23c0-.23,0-.47,0-.72-.1-1.6-.23-3.6.28-4.74A6.14,6.14,0,0,1,21.76,11h.47a6.15,6.15,0,0,1,5.71,3.68c.51,1.14.38,3.13.28,4.74v.07c0,.22,0,.44,0,.65a1,1,0,0,0,.66.23h0A3,3,0,0,0,30,20a.86.86,0,0,1,.35-.07,1.08,1.08,0,0,1,.41.08h0a.75.75,0,0,1,.57.61c0,.24-.18.59-1.06.94l-.33.11c-.5.16-1.26.4-1.5.95a1.29,1.29,0,0,0,.12,1.09h0c.06.15,1.58,3.62,5,4.18a.25.25,0,0,1,.21.26.42.42,0,0,1,0,.14c-.14.33-.77.79-3,1.13-.18,0-.25.26-.36.76,0,.18-.08.36-.13.54a.3.3,0,0,1-.32.24h0a2.77,2.77,0,0,1-.49-.06,6.59,6.59,0,0,0-1.33-.14,5.89,5.89,0,0,0-1,.08,4.59,4.59,0,0,0-1.82.93A5.14,5.14,0,0,1,22.15,33Z" />
        <path
          stroke="#000000"
          strokeOpacity="0.4"
          d="M22.23,11.22a5.9,5.9,0,0,1,5.48,3.53c.48,1.08.36,3,.26,4.62,0,.25,0,.49,0,.72v.1l.07.07a1.18,1.18,0,0,0,.84.31h0a3.26,3.26,0,0,0,1.24-.34.6.6,0,0,1,.25,0,.83.83,0,0,1,.31.06h0c.24.08.4.24.41.38s-.06.37-.9.7l-.32.11c-.55.17-1.37.44-1.65,1.09a1.53,1.53,0,0,0,.13,1.29c.1.23,1.66,3.74,5.17,4.32a.16.16,0,0,1,0,.06c-.06.14-.44.62-2.79,1-.37.06-.46.47-.56.95,0,.17-.08.34-.13.52s0,.06-.08.06h0a2.6,2.6,0,0,1-.45-.06,6.89,6.89,0,0,0-1.37-.15,6.13,6.13,0,0,0-1,.08,4.78,4.78,0,0,0-1.93,1,4.94,4.94,0,0,1-3,1.2h-.3a4.94,4.94,0,0,1-3-1.2,4.77,4.77,0,0,0-1.93-1,6.13,6.13,0,0,0-1-.08,6.78,6.78,0,0,0-1.37.15,2.79,2.79,0,0,1-.45.07c-.09,0-.09,0-.1-.07s-.09-.36-.13-.53c-.1-.48-.2-.89-.56-1-2.35-.36-2.73-.85-2.79-1a.16.16,0,0,1,0-.06c3.51-.58,5.07-4.09,5.17-4.32a1.53,1.53,0,0,0,.13-1.29c-.28-.65-1.1-.92-1.65-1.09l-.32-.11c-.71-.28-.93-.56-.89-.73s.38-.4.68-.4a.41.41,0,0,1,.17,0,3.17,3.17,0,0,0,1.31.34,1.21,1.21,0,0,0,.91-.32l.07-.07v-.1c0-.23,0-.47,0-.72-.1-1.58-.22-3.54.26-4.62a5.89,5.89,0,0,1,5.47-3.53h.47m0-.5h-.47a6.39,6.39,0,0,0-5.93,3.82c-.53,1.19-.4,3.22-.3,4.85,0,.19,0,.39,0,.58a1,1,0,0,1-.47.1,2.68,2.68,0,0,1-1.1-.3.89.89,0,0,0-.38-.08,1.19,1.19,0,0,0-1.17.8c-.07.35.09.85,1.2,1.29l.35.12c.46.15,1.15.37,1.34.81a1.07,1.07,0,0,1-.12.88v0c-.06.14-1.53,3.49-4.79,4a.5.5,0,0,0-.42.52.67.67,0,0,0,.05.22c.24.57,1.28,1,3.16,1.28a2.34,2.34,0,0,1,.17.57c0,.18.08.37.14.56a.56.56,0,0,0,.58.42,3,3,0,0,0,.54-.08A6.34,6.34,0,0,1,15.92,31a5.63,5.63,0,0,1,.92.08,4.35,4.35,0,0,1,1.72.89,5.42,5.42,0,0,0,3.29,1.29h.3A5.41,5.41,0,0,0,25.44,32a4.35,4.35,0,0,1,1.72-.89,5.62,5.62,0,0,1,.92-.08,6.38,6.38,0,0,1,1.28.14,3,3,0,0,0,.54.07h0a.54.54,0,0,0,.55-.42c.06-.19.1-.37.14-.56a2.32,2.32,0,0,1,.17-.57c1.88-.29,2.91-.71,3.16-1.28a.66.66,0,0,0,.05-.22.5.5,0,0,0-.42-.52c-3.26-.54-4.73-3.89-4.79-4v0a1.06,1.06,0,0,1-.12-.88c.19-.44.88-.66,1.34-.81l.35-.12c.81-.32,1.22-.72,1.21-1.17a1,1,0,0,0-.73-.84h0a1.34,1.34,0,0,0-.5-.1,1.11,1.11,0,0,0-.46.09,2.8,2.8,0,0,1-1,.29.92.92,0,0,1-.4-.1c0-.17,0-.34,0-.51V19.4c.1-1.63.23-3.66-.3-4.86a6.4,6.4,0,0,0-5.94-3.83Z"
        />
      </g>
    ),
    color: '#fffc00',
  },
  twitter: {
    logo: (
      <path
        data-test="twitter"
        d="M18.55,32.75a13.92,13.92,0,0,0,14-14c0-.21,0-.43,0-.64A10,10,0,0,0,35,15.56a9.83,9.83,0,0,1-2.83.77,4.94,4.94,0,0,0,2.16-2.72,9.87,9.87,0,0,1-3.13,1.2,4.93,4.93,0,0,0-8.39,4.49,14,14,0,0,1-10.15-5.14,4.93,4.93,0,0,0,1.52,6.57A4.89,4.89,0,0,1,12,20.1v.06a4.93,4.93,0,0,0,4,4.83,4.92,4.92,0,0,1-2.22.08,4.93,4.93,0,0,0,4.6,3.42,9.88,9.88,0,0,1-6.12,2.11A10,10,0,0,1,11,30.54a13.94,13.94,0,0,0,7.55,2.21"
      />
    ),
    color: '#1DA1F2',
  },
  youtube: {
    logo: (
      <path
        data-test="youtube"
        d="M33.5,16.19a3,3,0,0,0-2.12-2.14c-1.87-.5-9.38-.5-9.38-.5s-7.51,0-9.38.5a3,3,0,0,0-2.12,2.14A31.63,31.63,0,0,0,10,22a31.63,31.63,0,0,0,.5,5.81,3,3,0,0,0,2.12,2.14c1.87.5,9.38.5,9.38.5s7.51,0,9.38-.5a3,3,0,0,0,2.12-2.14A31.64,31.64,0,0,0,34,22,31.63,31.63,0,0,0,33.5,16.19Zm-14,9.38V18.43L25.82,22Z"
      />
    ),
    color: '#ff0000',
  },
  pinterest: {
    logo: (
      <path
        data-test="pinterest"
        d="m 18.067122,23.030522 c 0,-2.590933 -0.463,-3.488303 -0.463,-4.504751 0,-2.310748 1.755604,-2.499873 2.497885,-2.499873 1.057811,0 2.445158,0.677892 2.445158,1.945729 0,1.845328 -1.647681,2.078817 -1.647681,2.078817 0,0 0,0.645204 0,1.781508 0,1.19857 0.306469,2.755152 2.572853,2.755152 3.636431,0 4.01787,-4.788049 4.01787,-6.09947 0,-1.812641 -1.227522,-5.574901 -5.591404,-5.574901 -5.820433,0 -6.766201,4.913354 -6.766201,6.226331 0,0.561927 0.108746,1.651534 0.221613,2.075703 1.735008,0.404712 1.330502,1.848442 0.860089,2.253154 -0.682963,0.596172 -3.553223,0.712136 -3.553223,-4.854204 0,-5.301721 5.002359,-8.035857 9.393426,-8.035857 4.178519,0 8.731061,2.725575 8.731061,7.974373 0,4.683758 -3.564758,8.37208 -7.309111,8.37208 -2.247437,0 -3.439534,-1.749599 -3.439534,-1.749599 0,3.303847 -2.848839,8.038194 -3.256641,8.751887 0,0 1.28684,-6.112701 1.28684,-10.896079 z"
      />
    ),
    color: '#D32F2F',
  },
  googleplus: {
    logo: (
      <g>
        <rect id="rect233" height="8" width="2" y="16.591787" x="32.135605" />
        <rect id="rect235" height="2" width="8" y="19.591801" x="29.135586" />
        <path
          data-test="googleplus"
          id="path237"
          d="m 25.95059,19.79183 -0.05,-0.2 -8.765,0 0,3.000002 5.91,0 c -0.477,2.837005 -2.938,5.000008 -5.91,5.000008 -3.314,0 -6,-2.686004 -6,-6.000009 0,-3.314001 2.686,-6.000001 6,-6.000001 1.5,0 2.868,0.554 3.92,1.465 l 2.151,-2.106 c -1.6,-1.465 -3.731,-2.359 -6.071,-2.359 -4.971,0 -8.999997,4.029 -8.999997,9.000001 0,4.971007 4.028997,9.000014 8.999997,9.000014 4.971,0 9,-4.029007 9,-9.000014 0,-0.617001 -0.066,-1.218001 -0.185,-1.800001 z"
        />
      </g>
    ),
    color: '#F4511E',
  },
  email: {
    logo: (
      <g transform="translate(5 5)">
        <path
          data-test="email"
          d="M25.2,8.6h-16c-1.1,0-2,0.9-2,2l0,12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-12C27.2,9.5,26.3,8.6,25.2,8.6z
          M25.2,12.6l-8,5l-8-5v-2l8,5l8-5V12.6z"
        />
      </g>
    ),
    color: '#7D9267',
  },
  sms: {
    logo: (
      <g transform="translate(5 5)">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M24.3,7.2H9.9c-1,0-1.8,0.9-1.8,2l0,18l3.6-4h12.6c1,0,1.8-0.9,1.8-2v-12C26.1,8.1,25.2,7.2,24.3,7.2z    M14.4,16.2h-1.8v-2h1.8V16.2z M18,16.2h-1.8v-2H18V16.2z M21.6,16.2h-1.8v-2h1.8V16.2z"
        />
      </g>
    ),
    color: '#385595',
  },
}

const Svg = styled.svg.attrs({
  focusable: 'false',
  height: (props) => props.size,
  role: 'presentation',
  width: (props) => props.size,
  viewBox: '0 0 44 44',
})`
  cursor: pointer;
  user-select: none;
  fill: #fff;

  circle#bgCircle {
    fill: ${({ type }) => types[type].color};
    stroke: ${({ type }) => types[type].color};
    stroke-width: 0;
    transition: stroke-width 100ms ease;
  }

  &:hover {
    circle#bgCircle {
      stroke-width: 4px;
    }
  }
`

const SocialIcon = (props) => {
  return (
    <Svg {...props}>
      <circle id="bgCircle" cx="22" cy="22" r="20" />
      {types[props.type].logo}
    </Svg>
  )
}

SocialIcon.propTypes = {
  type: PropTypes.oneOf(Object.keys(types)),
}

SocialIcon.defaultProps = {
  size: '44px',
  type: 'facebook',
}

export default SocialIcon
